<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
  },
  data() {
    return {
      loading: true,
      loadError: null,
      list: [],
    };
  },
  methods: {
    getAgendamentos() {
      this.loading = true;
      this.loadError = null;

      api
        .get("telemedicina/agendamentos")
        .then((response) => {
          if (response.data.status === "success") {
            this.list = response.data.list;
          } else {
            this.loadError =
              response.data.message ||
              "Não foi possível carregar os agendamentos.";
          }
        })
        .catch(() => {
          this.loadError = "Falha na comunicação com o servidor. Tente novamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getAgendamentos();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Meus Agendamentos</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Agendamentos</h3>
        <p>Acompanhe suas consultas online agendadas.</p>
      </div>
    </div>

    <b-alert v-if="loadError" show variant="danger">{{ loadError }}</b-alert>

    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
      </div>
    </div>

    <div class="card" v-else-if="!loadError && list.length == 0">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum agendamento encontrado.
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-else-if="!loadError">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-centered table-nowrap mb-0">
            <thead class="thead-light">
              <tr>
                <th>Data</th>
                <th>Especialidade</th>
                <th class="d-none d-md-table-cell">Profissional</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in list" :key="row.id + '-' + index">
                <td>
                  <strong>{{ row.date }}</strong>
                  <div class="text-muted font-size-13">{{ row.time }}</div>
                </td>
                <td>{{ row.specialty }}</td>
                <td class="d-none d-md-table-cell">{{ row.doctor_name }}</td>
                <td class="text-right">
                  <router-link :to="'/telemedicina/agendamentos/' + row.id" class="btn btn-default btn-sm btn-rounded">
                    Ver
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>
